import React, { Component, PropTypes } from 'react';
import { Col, FormGroup } from 'react-bootstrap';
import Make from '../../coverNotePVComponent/make/Make';
import Model from '../../coverNotePVComponent/model/Model';
import Tonnage from '../../coverNotePVComponent/tonnage/Tonnage';
import ModelDesc from '../../coverNotePVComponent/modelDesc/ModelDesc';
import EngineNo from '../../coverNotePVComponent/engineNo/EngineNo';
import YearOfManufacture from '../../coverNotePVComponent/yearOfManufacture/YearOfManufacture';
import VehicleRegNo from '../../coverNotePVComponent/vehicleRegNo/VehicleRegNo';
import ChassisNo from '../../coverNotePVComponent/chassisNo/ChassisNo';
import HorsePower from '../../coverNotePVComponent/horsePower/HorsePower';
import TypeOfBody from '../../coverNotePVComponent/typeOfBody/TypeOfBody';
import ExistingCoverNote from '../../coverNotePVComponent/existingCoverNote/ExistingCoverNote';


class ParticularOfVehicle extends Component {

  constructor(props) {
    super(props);
    this.state = {
      option: []
    }
  }

  render() {
    return (
      <div className="ebaoUtil__Top-Bottom-Line">
        <h3 className="ebaoUtil__HeaderThree">Particular of Vehicle</h3>
          <FormGroup controlId="">
            <Col sm={6}>
              <Make
                handleChangeMake={this.props.handleChangeParticularOfVehicle}
                make={this.props.particularOfVehicle.make}
              />
            </Col>
            <Col sm={6}>
              <Model
                option={this.props.option}
                handleChangeModel={this.props.handleChangeParticularOfVehicle}
                model={this.props.particularOfVehicle.model}
              />
            </Col>
          </FormGroup>
          <FormGroup controlId="">
            <Col sm={6}>
              <Tonnage
                tonnage={this.props.particularOfVehicle.tonnage}
                handleChangeTonnage={this.props.handleChangeParticularOfVehicle}
              />
            </Col>
            <Col sm={6}>
              <ModelDesc
                modelDesc={this.props.particularOfVehicle.modelDesc}
                handleChangeModelDesc={this.props.handleChangeParticularOfVehicle}
              />
            </Col>
          </FormGroup>
          <FormGroup controlId="">
            <Col sm={6}>
              <EngineNo
                engine={this.props.particularOfVehicle.engineNo}
                handleChangeEngine={this.props.handleChangeParticularOfVehicle}
              />
            </Col>
            <Col sm={6}>
              <YearOfManufacture
                yearOfManufacture={this.props.particularOfVehicle.yearOfManufacture}
                handleChangeYearOfManufacture={this.props.handleChangeParticularOfVehicle}
              />
            </Col>
          </FormGroup>
          <FormGroup controlId="">
            <Col sm={6}>
              <VehicleRegNo
                vehicleRegNo={this.props.particularOfVehicle.vehicleRegNo}
                validation={this.props.validation}
                handleChangeVehicleRegNo={this.props.handleChangeParticularOfVehicle}
              />
            </Col>
            <Col sm={6}>
              <ChassisNo
                chassisNo={this.props.particularOfVehicle.chassisNo}
                handleChangeChassisNo={this.props.handleChangeParticularOfVehicle}
                getExistingCoverNote={this.props.getExistingCoverNote}
              />
            </Col>
          </FormGroup>
          <FormGroup controlId="">
            <Col sm={6}>
              <TypeOfBody
                typeOfBody={this.props.particularOfVehicle.typeOfBody}
                handleChangeTypeOfBody={this.props.handleChangeParticularOfVehicle}
              />
            </Col>
            <Col sm={6}>
              <HorsePower
                horsePower={this.props.particularOfVehicle.horsePower}
                handleChangeHorsePower={this.props.handleChangeParticularOfVehicle}
              />
            </Col>
          </FormGroup>
          <ExistingCoverNote
            existingCoverNotes={this.props.existingCoverNotes}
          />

      </div>
    )
  }
}

ParticularOfVehicle.propTypes = {
  particularOfVehicle: PropTypes.object,
  handleChangeParticularOfVehicle: PropTypes.func,
  option: PropTypes.array,
  existingCoverNotes: PropTypes.array,
  validation: PropTypes.func,
  getExistingCoverNote: PropTypes.func
};

export default ParticularOfVehicle;



// WEBPACK FOOTER //
// ./src/app/components/coverNotePVComponent/particularOfVehicle/ParticularOfVehicle.js